import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
export const Datepicker = ({ date, onChange, label, minDate, maxDate, className }) => {
    return (React.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils },
        React.createElement("div", { className: className },
            React.createElement(KeyboardDatePicker, { disableToolbar: true, format: "MMM d yyyy", label: label, maxDate: maxDate, minDate: minDate, onChange: onChange, value: date, variant: "inline" }))));
};
